<template>
    <div class="home">  
        <!-- SKY -->        
        <div ref="bg_moonlight" class="container-bg-moon" data-relative-input="true">
            <div class="bg-moon" data-depth="0.2">
                <div class="bg"></div>
        </div>
        </div>
        <div class="container-bg-stars" ref="stars">
            <div class="bg" data-depth="0.2">
                <img src="@/assets/images/home/moon/stars.svg" alt="stars">
            </div>
        </div>
        <full-page ref="fullpage" :options="options" id="fullpage">
            <!-- Section profile -->
            <profile-h :render="render_profile" :leave="leave_profile">
            </profile-h>
            <div class="section">
                <info-section :data="about_me_data" :render="about_me_data.render" :leave="about_me_data.leave"></info-section>
            </div>
            <div class="section">
                <info-section :data="works_data" :render="works_data.render" :leave="works_data.leave"></info-section>
            </div>
            <div class="section">
                <info-section :data="contact_data" :render="contact_data.render" :leave="contact_data.leave"></info-section>
            </div>
        </full-page>
        <div class="items-page">
            <span
                title="Perfil"
                @click="goToSection('perfil')" 
                :class="{ 'item-active': current_section == 'perfil' }"></span>
            <span
                title="Sobre mi"
                @click="goToSection('sobre-mi')" 
                :class="{ 'item-active': current_section == 'sobre-mi' }"></span>
            <span
                title="Trabajos"
                @click="goToSection('trabajos')" 
                :class="{ 'item-active': current_section == 'trabajos' }"></span>
            <span
                title="Contacto"
                @click="goToSection('contacto')" 
                :class="{ 'item-active': current_section == 'contacto' }"></span>
        </div>
    </div>
</template>

<script>
import Parallax from 'parallax-js'
import { TweenMax, Power2, TimelineLite } from "gsap/TweenMax";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ProfileComponent from '@/components/ProfileComponent'
import InfoSectionComponent from '@/components/InfoSectionComponent'

export default {
    components: {
        'profile-h': ProfileComponent,
        'info-section': InfoSectionComponent
    },
    data() {
        return {
            // Actual route
            current_section: 'perfil',
            // Profile
            render_profile: false,
            leave_profile: false,
            // About Me
            about_me_data: {
                type: 'home',
                render: false,
                leave: false,
                title: 'QUIÉN SOY YO',
                description: 'Amante de la Tecnología, los Animales y de adquirir Nuevo Conocimiento.',
                button_link: { type: 'local', link: 'about-me' },
                image: { url: 'home/me.jpg' }
            },
            // Works
            works_data: {
                type: 'home',
                render: false,
                leave: false,
                title: 'MIS TRABAJOS',
                description: 'Estos son algúnos proyectos recientes en los que he trabajado.',
                button_link: { type: 'local', link: 'works' },
                image: { url: 'home/works.jpg' }
            },
            // Contacto
            contact_data: {
                type: 'home',
                render: false,
                leave: false,
                title: 'CONTÁCTAME',
                description: 'Si tienes un Proyecto Increíble y necesitas Desarrollo Web Profesional no dudes en contáctarme.',
                // button_link: {},
                social_networks: true,
                image: { url: 'home/contact.jpg' }
            },
            options: {
                licenseKey: 'YOUR_KEY_HEERE',
                // menu: '#menu',
                // navigation: true,    
                // verticalCentered: false,
                scrollingSpeed: 1180,
                anchors: ['perfil', 'sobre-mi', 'trabajos', 'contacto'],
                //sectionsColor: ['#040E1A', '#040E1A', '#040E1A', '#040E1A'],
                onLeave: this.onLeaveAnimations
            }
        }
    },
    mounted() {
        let  parallax_stars = new Parallax(this.$refs.stars),
             parallax_moonlight = new Parallax(this.$refs.bg_moonlight)
    },
    methods: {
        goToSection(section) {
            this.$refs.fullpage.api.moveTo(section);
        },
        onLeaveAnimations(origin, destination, direction) {
            this.current_section = destination.anchor;
            // PROFILE
            if (origin.anchor == 'perfil') {
                this.leave_profile = !this.leave_profile;
            }
            if (origin.anchor == 'sobre-mi' && direction == 'up') {
                this.render_profile = !this.render_profile;
            }
            if (origin.anchor == 'contacto') {
                this.render_profile = !this.render_profile;
            }
            // ABOUT ME
            if (origin.anchor == 'sobre-mi') {
                this.about_me_data.leave = !this.about_me_data.leave;
            } 
            if (destination.anchor == 'sobre-mi') {
                this.about_me_data.render = !this.about_me_data.render;
            }
            // WORKS
            if (origin.anchor == 'trabajos') {
                this.works_data.leave = !this.works_data.leave;
            } 
            if (destination.anchor == 'trabajos') {
                this.works_data.render = !this.works_data.render;
            } 
            // CONTACT  
            if (origin.anchor == 'contacto') {
                this.contact_data.leave = !this.contact_data.leave;
            } 
            if (destination.anchor == 'contacto') {
                this.contact_data.render = !this.contact_data.render;
            }         
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import '@/assets/css/_mixins.scss';
    .home {
        color: #FFFFFF;
        position: relative;

        #fullpage { z-index: 2 }

        .items-page {
            // border: 1px solid red;
            position: fixed;
            z-index: 5;
            width: 100%;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            padding-bottom: 18px;

            .item-active { height: 28px }
            span {
                width: 2px;
                height: 16px;
                margin-right: 32px;
                background-color: #FFFFFF;
                cursor: pointer;
                @include transition(width 0.5s);

                &:last-child { margin-right: 0px }
            }

            @media (min-width: 760px) {
                padding-bottom: 30px;

                .item-active { height: 40px }
                span {
                    width: 3px;
                    height: 25px;
                    margin-right: 60px;
                }
            }

            @media (min-width: 1200px) {
                top: 0;
                left: 0;
                width: initial;
                flex-direction: column;
                align-items: flex-start;
                padding-bottom: 0px;
                padding-left: 10px;

                .item-active {
                    width: 50px; 
                    height: 3px
                }
                span {
                    width: 30px;
                    height: 3px;
                    margin-right: 0px;
                    margin-bottom: 40px;
                }
            }

            @media (min-width: 1600px) {
                padding-left: 35px;
            }
        }
        
        // DEBO PONERLE [!IMPORTANT] A TODOS LOS ESTILOS PARA SUPEPONER A LOS DE PARALLAX-JS
        .container-bg-moon {
            position: fixed !important;
            left: 0 !important;
            right: 0 !important;  
            height: 100% !important;
            max-height: 670px !important;
            background-color: #040E1A;
            z-index: 1;

            .bg-moon {
                position: absolute !important;
                width: 165vw !important;
                height: 165vw !important;
                top: -7rem !important;
                margin: auto !important;
                left: -35% !important;

                .bg {
                    position: relative !important;
                    background-image: url(~@/assets/images/home/moon/moonlight.svg);
                    background-size: 100% 100% !important;
                    width: 100% !important;
                    height: 100% !important;
                }
            }

            @media (min-width: 768px) {
                max-height: initial !important;
                .bg-moon {
                    width: 100vw !important;
                    height: 100vw !important; 
                    left: 23% !important;
                    top: 0 !important;
                    bottom: 0 !important;
                }
            }

            @media (min-width: 1024px) {

                .bg-moon {
                    left: 30% !important;
                    width: 1350px !important;
                    height: 1350px !important;
                }
            }
        }

        .container-bg-stars {
            position: fixed;
            left: 0;
            right: 0;
            height: 100vh;
            max-height: 500px;
            z-index: 3;

            .bg {                
                img {
                    width: 100%;
                    height: auto;     
                    @include transform(translate3d(0%, 35%, 0) scale(1.5));
                }
            }

            @media (min-width: 760px) {
                max-height: initial;
                left: 30%;

                .bg {            
                    display: flex !important;
                    align-items: center;
                    height: 100%;
                    img { @include transform(translate3d(0%, 0%, 0) scale(1.3)); }
                }
            }

            @media (min-width: 1024px) {
                width: 1300px;
                left: 30% !important;
                .bg {                                
                    img { @include transform(translate3d(0%, 0%, 0) scale(1)); }
                }
            }
        }
    }
</style>

